<template>
  <div class="sidebar-page">
    <aside class="sidebar">
      <slot name="sidebar"/>
    </aside>

    <main>
      <slot name="page"/>
    </main>
  </div>
</template>

<style lang="scss" src="./SidebarPage.scss"/>

<!--Используется в реестре транспорта и характеристик -->
<script lang="ts">
export default defineComponent({
  name: 'SidebarPage',
});
</script>
